<template>
  <v-tooltip
    bottom
    v-model="modelShow"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        class="flex"
        style="width: fit-content;"
        data-testid="tooltip-trigger-div"
      >
        <Chip v-bind="$attrs" />
      </div>
    </template>
    <span data-testid="tooltip-content-span">{{ tooltipContent }}</span>
  </v-tooltip>
</template>

<script>
import Chip from "./Chip.vue";

export default {
  props: {
    tooltipContent: {
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Chip,
  },
  data() {
    return {
      tipShow: false,
    };
  },
  computed: {
    modelShow: {
      get() {
        return this.show || this.tipShow
      },
      set(value) {
        this.tipShow = value
        this.$emit("change", value);
      }
    }
  }
};
</script>
